module.exports = __webpack_public_path__ + "static/holiday_big-30619de8e4446ebb20e392cbf3a2c90e.jpg";